
import { Component, Vue, Prop } from 'vue-property-decorator';
import EndCircleSvg from '@/iconSVG/EndCircleSvg.vue'
import EndCircleSvgChecked from '@/iconSVG/EndCircleSvgChecked.vue'

@Component({
    components:{
        EndCircleSvg,
        EndCircleSvgChecked
    }
})
export default class EndCircle extends Vue {


    @Prop({required: false})
    titleStyle!: any;

    @Prop({required: false})
    completed!: boolean;

    @Prop({required: false})
    stepTitle!: string;

    public action(){
        this.$emit('action')
    }

}
